export default __webpack_public_path__ + "static/media/addtocart-icon.b04207ec.svg";